import { IApplicationState } from '../../types/redux';

export const getTransportAccessibilitySource = (state: IApplicationState): string => {
  const { transportAccessibility } = state.newbuilding;

  if (!transportAccessibility) {
    return '/';
  }

  return transportAccessibility.sourceUrl;
};
